import SpirometriaList from "./pages/SpirometriaList.vue"
import SpirometriaEdit from "./pages/SpirometriaEdit.vue"
import SpirometriaView from "./pages/SpirometriaView.vue"

export default{
    SpirometriaList,
    SpirometriaEdit,
    SpirometriaView,
}